

































import Vue from 'vue'
import appsBar from './components/appsBar/index.vue'
import snackBar from './components/snackBar/index.vue'

export default Vue.extend({
  name: 'App',
  components: {
    appsBar,
    snackBar
  },
  data: () => ({
    apps: {}
  }),
  created () {
    this.apps = this.$store.state.apps
    if (this.$cookies.get('username') !== null && this.$cookies.get('password') !== null) this.login(this.$cookies.get('username'), this.$cookies.get('password'))
  },
  methods: {
    login (username: any, password: any) {
      if (username === 'Admin' && password === 'password') {
        this.$store.commit('setLoginStatus', true)
        this.$cookies.set('username', username)
        this.$cookies.set('password', password)
      } else {
        this.$store.commit('setSnackBar', {
          icon: 'fas fa-exclamation-triangle',
          color: 'error',
          message: 'Login Fail: invalid username or password',
          status: true
        })
      }
    }
  }
})
